import React, { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import api from "src/services/api";
import TaigaCommentContent from "./TaigaCommentContent";
import "./CommentsModal.css";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";

function formatarData(iso) {
  return new Date(iso).toLocaleString("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function CommentsModal({ card, onClose }) {
  const [comentarios, setComentarios] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const open = !!card;
  const userStoryId = card?.id_historia_de_usuario;

  useEffect(() => {
    if (!userStoryId) return;
    let cancelled = false;

    const load = async () => {
      setLoading(true);
      setError("");
      setComentarios([]);
      try {
        const { data } = await api.get("/comentarioUserStory", {
          params: { userStoryId },
        });
        if (!cancelled) {
          const lista = Array.isArray(data) ? data : [];
          // não mostra comentários apagados/ocultos e ordena do mais novo pro mais antigo
          setComentarios(
            lista
              .filter((c) => !c.delete_comment_date && !c.is_hidden)
              .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
          );
        }
      } catch (err) {
        console.error("Erro ao buscar comentários:", err);
        if (!cancelled) {
          setError(
            err.response?.status === 404
              ? "Esta história não está mais disponível no Taiga."
              : "Não foi possível carregar os comentários.",
          );
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    load();
    return () => {
      cancelled = true;
    };
  }, [userStoryId]);

  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
      <DialogContent className="max-h-[85vh] max-w-2xl overflow-hidden">
        <DialogHeader>
          <DialogTitle className="break-words pr-6">
            {card?.titulo_hu}
          </DialogTitle>
        </DialogHeader>

        <div className="flex max-h-[65vh] flex-col gap-4 overflow-y-auto pr-1">
          {loading ? (
            <div className="flex items-center justify-center gap-2 py-10 text-gray-500">
              <Loader2 className="h-5 w-5 animate-spin" />
              Carregando comentários...
            </div>
          ) : error ? (
            <p className="py-10 text-center text-red-600">{error}</p>
          ) : comentarios.length === 0 ? (
            <p className="py-10 text-center text-gray-500">
              Nenhum comentário nesta história.
            </p>
          ) : (
            comentarios.map((c) => (
              <div key={c.id} className="flex gap-3">
                <img
                  src={c.user.photo}
                  alt={c.user.name}
                  className="h-8 w-8 shrink-0 rounded-full object-cover"
                />
                <div className="min-w-0 flex-1 rounded-lg bg-gray-100 p-3">
                  <div className="flex items-baseline justify-between gap-2">
                    <span className="text-sm font-semibold text-[#020817]">
                      {c.user.name}
                    </span>
                    <span className="text-xs text-gray-400">
                      {formatarData(c.created_at)}
                      {c.edit_comment_date && " (editado)"}
                    </span>
                  </div>
                  <TaigaCommentContent
                    html={c.comment_html}
                    text={c.comment}
                  />
                </div>
              </div>
            ))
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
